import * as types from '../mutation-types'
import * as apis from '../../apis'

const state = {
    coupons: [],
    usedCoupons: [],
    usedCouponsMeta: {},
    expiredCoupons: [],
    expiredCouponsMeta: {},
};

const getters = {
    coupons: state => state.coupons,
    usedCoupons: state => state.usedCoupons,
    usedCouponsMeta: state => state.usedCouponsMeta,
    expiredCoupons: state => state.expiredCoupons,
    expiredCouponsMeta: state => state.expiredCouponsMeta,
};

const actions = {
    addCoupon({ commit }, payload) {
        return apis.addCoupon(payload).then(res => {
            let coupon = res.data;
            coupon.isNew = true;

            commit(types.ADD_COUPON, res.data);

            return res.data;
        });
    },
    getCoupons({ commit }, payload = {}) {
        return apis.getCoupons(payload).then(res => {
            commit(types.SET_COUPONS, res.data);
            return res;
        })
    },
    getUsedCoupons({ commit }, payload = {}) {
        return apis.getUsedCoupons(payload).then(res => {
            commit(types.SET_USED_COUPONS, res.data);
            return res;
        })
    },
    loadMoreUsedCoupons({ commit, state }) {
        let payload = {
            page: state.usedCouponsMeta.current_page + 1
        };

        return apis.getUsedCoupons(payload).then(res => {
            commit(types.LOAD_MORE_USED_COUPONS, res.data);
            return res;
        })
    },
    getExpiredCoupons({ commit }, payload = {}) {
        return apis.getExpiredCoupons(payload).then(res => {
            commit(types.SET_EXPIRED_COUPONS, res.data);
            return res;
        })
    },
    loadMoreExpiredCoupons({ commit, state }) {
        let payload = {
            page: state.expiredCouponsMeta.current_page + 1
        };

        return apis.getExpiredCoupons(payload).then(res => {
            commit(types.LOAD_MORE_EXPIRED_COUPONS, res.data);
            return res;
        })
    },
};

const mutations = {
    [types.SET_COUPONS](state, coupons) {
        state.coupons = coupons;
    },
    [types.SET_USED_COUPONS](state, coupons) {
        state.usedCouponsMeta = coupons.meta;
        state.usedCoupons = coupons.data;
    },
    [types.LOAD_MORE_USED_COUPONS](state, coupons) {
        state.usedCouponsMeta = coupons.meta;
        state.usedCoupons = state.usedCoupons.concat(coupons.data).filter((coupon, index, coupons) => {
            return coupons.findIndex(o => o.id === coupon.id) === index;
        });
    },
    [types.SET_EXPIRED_COUPONS](state, coupons) {
        state.expiredCouponsMeta = coupons.meta;
        state.expiredCoupons = coupons.data;
    },
    [types.LOAD_MORE_EXPIRED_COUPONS](state, coupons) {
        state.expiredCouponsMeta = coupons.meta;
        state.expiredCoupons = state.expiredCoupons.concat(coupons.data).filter((coupon, index, coupons) => {
            return coupons.findIndex(o => o.id === coupon.id) === index;
        });
    },
    [types.ADD_COUPON](state, coupon) {
        state.coupons.unshift(coupon)
    }
};

export default {
    state,
    getters,
    actions,
    mutations,
};
